<template>
  <div id="app" style="margin-top: 0px">
    <div :style="'height:' +
      (_isMobile() ? '90' : '70') +
      'px;background:rgb(9,136,91);overflow: hidden;z-index:1000;position:relative;'
      ">
      <img style="
          position: absolute;
          top: 20px;
          left: 20px;
          width: 50px;
          height: 50px;
        " src="../../assets/img/sjtu.png" />
      <img style="
          position: absolute;
          top: 20px;
          left: 90px;
          width: 50px;
          height: 50px;
        " src="../../assets/img/life.png" />
      <div style="
          display: flex;
          flex-direction: row;
          align-items: center;
          margin-top: 20px;
          justify-content: flex-end;
          padding-right: 20px;
        ">
        <iSwitch v-if="!_isMobile()" @on-change="levelOpen = $event" :value="true" size="large">
          <span slot="open">下拉</span>
          <span slot="close">重叠</span>
        </iSwitch>
        <Input search enter-button placeholder="搜索会议室"
          :style="'margin-left:20px;' + (_isMobile() ? 'margin-top:10px' : '')" v-model="search" style="width: 160px" />
      </div>
      <div v-if="!_isMobile()" style="position: absolute; color: #fff; top: 25px; left: 160px">
        <p style="font-size: 21px; font-family: KaiTi">
          上海交通大学 生命科学技术学院
        </p>
        <p style="font-size: 12px">
          School of Lifesciences & Biotechnology, SJTU Copyright
        </p>
      </div>
    </div>
    <row v-if="_isMobile()" style="padding: 1%; height: 60px" class="User">
      <a class="navToggle" style="position: relative; left: 40px; margin-right: 40px; width: 200px">
        <span style="left: -30px"></span>
        <div style="
            text-align: left;
            color: #515a6e;
            margin-left: 10px;
            padding-top: -3px;
            font-size: 16px;
          ">
          智慧会议室
        </div>
      </a>
      <div style="position: absolute; right: 0; margin-top: -12px">
        <span v-if="!user.name">
          <Button type="primary" @click="
      loginmodal = true;
    registered = true;
    ">登陆</Button>
          <Button type="primary" @click="
      loginmodal = true;
    registered = false;
    ">注册</Button>
        </span>
        <span v-else>
          <Button type="primary" @click="routergoto(base + '/userMenu')">{{
      user.name || "我的账户"
    }}</Button>
          <Button type="warning" @click="goLogout">退出</Button>
        </span>
      </div>
    </row>
    <Menu v-else mode="horizontal" theme="dark" active-name="1" style="
        margin-top: -10px;
        font-size: 1em;
        text-align: left;
        background: #09885b;
      " class="mainNav">
      <Submenu :is="i.submenu ? 'Submenu' : 'MenuItem'" v-for="(i, ind) in menulist" :key="ind" style="font-size: 16px;"
        @click.prevent="
      routergoto(base + (i.to ? i.to : '/cmsChannel/' + i.id))
      " :to="base + (i.to ? i.to : '/cmsChannel/' + i.id)" :name="i.name || '/'">
        <template v-if="i.submenu" slot="title">
          <Icon type="ios-stats" />
          {{ i.name }}
        </template>
        <Icon v-else type="ios-paper" />
        {{ i.submenu ? "" : i.name }}
        <MenuGroup :is="sm.submenu && sm.submenu.length ? 'MenuGroup' : 'MenuItem'" v-for="(sm, index) in i.submenu"
          :key="index" :name="sm.id || sm.name" :title="sm.name" :to="base + (sm.to ? sm.to : '/cmsContent/' + sm.id)">
          <MenuItem v-for="(item, idx) in sm.submenu" :key="idx" :name="item.id || item.name || '/'" :title="item.name"
            :to="base + (item.to ? item.to : '/cmsContent/' + item.id)">
          {{ item.name }}
          </MenuItem>
          {{ sm.submenu && sm.submenu.length ? "" : sm.name }}
        </MenuGroup>
      </Submenu>
      <div style="float: right" class="User">
        <MenuItem v-if="!user.id" name="5">
        <Button type="primary" @click="
      loginmodal = true;
    registered = true;
    ">登陆<span class="button-rad"></span></Button>
        <Button type="primary" @click="
      loginmodal = true;
    registered = false;
    ">注册</Button>
        </MenuItem>
        <MenuItem v-else name="7">
        <Button type="primary" @click="myInfo">{{
      user.name || "我的账户"
    }}</Button>
        <Button type="warning" @click="goLogout">退出</Button>
        </MenuItem>
      </div>
    </Menu>
    <div id="container">
      <header>
        <nav id="main-nav" class="hc-nav hc-nav-1">
          <navi :menulist="menulist" :levelOpen="levelOpen"></navi>
        </nav>
      </header>

      <main style="
          width: 100%;
          min-height: 600px;
          padding-bottom: 0;
          position: relative;
        ">
        <keep-alive :include="['apparatusCategory']">
          <router-view @routerswitch="routergoto" @childEvent="childEvent" class="rtv" />
        </keep-alive>
        <Spin fix v-show="spining">
          <Icon type="ios-loading" size="18" class="demo-spin-icon-load"></Icon>
          <div>Loading</div>
        </Spin>
        <bottom @childEvent="childEvent" style="z-index: 900"> </bottom>
      </main>
      <div style="height: 60px"></div>
      <Modal v-model="loginmodal" :style="'top:' + loginmodal ? '-1000px;' : 'auto;'" class="Login">
        <div slot="header">
          <label :class="{ sep: true, pressed: registered }" @click="registered = true">登陆</label>
          <label :class="{ sep: true, pressed: !registered }" @click="registered = false;">注册</label>
        </div>
        <Form v-show="registered" class="iform">
          <Form-item>
            <i-input v-model="loginData.username" placeholder="用户名 username" type="text">
              <Icon type="ios-person-outline" slot="prepend"></Icon>
            </i-input>
          </Form-item>
          <Form-item>
            <i-input @on-keyup.enter="subLogin" v-model="loginData.password" placeholder="密码 password" type="password">
              <Icon type="ios-lock-outline" slot="prepend"></Icon>
            </i-input>
          </Form-item>
        </Form>
        <Form v-show="!registered" class="iform" action="/register" method="post">
          <Form-item>
            <i-input v-model="loginData.username" placeholder="用户名 username" type="text">
              <Icon type="ios-person-outline" slot="prepend"></Icon>
            </i-input>
          </Form-item>
          <Form-item>
            <i-input v-model="loginData.password" placeholder="密码  password" type="password">
              <Icon type="ios-lock-outline" slot="prepend"></Icon>
            </i-input>
          </Form-item>
          <Form-item>
            <i-input v-model="loginData.password2" placeholder="重复密码 repeat password" type="password">
              <Icon type="ios-lock-outline" slot="prepend"></Icon>
            </i-input>
          </Form-item>
          <Form-item>
            <i-input v-model="loginData.name" placeholder="真实姓名 real name" type="text">
              <Icon type="md-person" slot="prepend"></Icon>
            </i-input>
          </Form-item>
          <Form-item>
            <i-input v-model="loginData.mobile" placeholder="手机号码 mobile" type="text">
              <Icon type="md-phone-portrait" slot="prepend"></Icon>
            </i-input>
          </Form-item>
          <Form-item>
            <i-input v-model="loginData.email" placeholder="邮箱 email" type="text">
              <Icon type="md-mail" slot="prepend"></Icon>
            </i-input>
          </Form-item>
          <Form-item>
            <i-switch v-model="loginData.sex" placeholder="性别 sex" type="text">
              <Icon type="md-sex" slot="prepend"></Icon>
            </i-switch>
            {{ loginData.sex ? "男" : "女" }}
          </Form-item>
        </Form>
        <div slot="footer" style="display: flex; justify-content: space-around">
          <i-button type="info" @click="jaccountLogin" :loading="modal_loading" style="width: 65%">jAccount
            一键登陆</i-button>
          <i-button type="primary" @click="subLogin" :loading="modal_loading" style="width: 30%">{{ registered ? "登陆" :
      "注册" }}</i-button>
        </div>
      </Modal>
      <Modal v-model="confirmShow" class="confirm" :title="'操作确认'">
        <div slot="footer">
          <Button type="primary" @click="
      confirmOptions.resolve();
    confirmShow = false;
    ">
            {{ confirmOptions.okText || "确定" }}
          </Button>
          <Button type="warning" @click="
      confirmOptions.reject();
    confirmShow = false;
    ">
            {{ confirmOptions.cancelText || "取消" }}
          </Button>
        </div>
      </Modal>
      <welcome />
    </div>
  </div>
</template>

<script>
import navi from "@/components/nav.vue";
import bottom from "@/components/bottom.vue";
import welcome from "@/components/welcome.vue";
export default {
  name: "app",
  components: {
    navi,
    bottom,
    welcome,
  },
  data: function () {
    return {
      menulist: [],
      loginmodal: false,
      modal_loading: false,
      registered: true,
      state: this.$store.state,
      levelOpen: true,
      loginData: { sex: true },
      currentView: {},
      spining: false,
      confirmShow: false,
      confirmOptions: {
        okText: "",
        cancelText: "",
        resolve: () => {
          console.log("ok!");
        },
        reject: () => {
          console.log("Bad!");
        },
      },
    };
  },
  provide: function () {
    return {
      routergoto: this.routergoto,
    };
  },
  created() {
    console.log(1, this.menulist);
    this.db_api("post", this.api, { req: "get_menu_list" }).then((res) => {
      this.menulist = [{ name: "智慧会议室", to: "/rooms" },].concat(res[0].result);
      console.log(2, res);
    }).catch(() => this.menulist = []);
  },
  computed: {
    user() {
      return this.$store.state.user;
    },
    search: {
      get() {
        return this.$store.state.search;
      },
      set(s) {
        this.$store.commit("setSearch", s);
      },
    },
  },
  watch: {
    registered(n) {
      if (!n) window.location.href = 'https://biocore.sjtu.edu.cn/sjtu/frontend/register';
    },
    "loginData.password"(n) {
      if (
        n &&
        this.loginData.password2 &&
        n != this.loginData.password2 &&
        n.length == this.loginData.password2.length
      ) {
        this.$Message.error("两次密码不一致");
      }
    },
    "loginData.password2"(n) {
      if (
        n &&
        this.loginData.password &&
        n != this.loginData.password &&
        n.length == this.loginData.password.length
      ) {
        this.$Message.error("两次密码不一致");
      }
    },
    "$store.state.user.id"(n) {
      if (n) {
        this.loginmodal = false;
        this.$router.replace({ path: "/refresh" });
        this.$Message.info({
          content: this.user.name + "欢迎回来！",
          background: true,
        });
      }
    },
  },
  mounted() {
    this.window = window;
    let initData = {};
    const t = Math.ceil(document.body.clientHeight / 3);
    document.getElementsByClassName(
      "confirm"
    )[0].children[1].children[0].style.top = t + "px";
    this.$Message.config({ top: t, background: true, duration: 3 });
    let query = window.location.search;
    initData = window.initData;
    console.log(123, initData);
    if (initData.path) {
      this.routergoto({
        path: this.base + "/" + initData.path,
        query: query.slice(1, query.length),
      });
    }
  },
  methods: {
    routergoto(para) {
      this.spining = true;
      setTimeout(() => (this.spining = false), 300);
      console.log("pathpara", para, this.$route);
      if (para.query && !para.params) {
        let n = this.$router.options.routes.findIndex(
          (i) => i.path == para.path
        );
        if (n > -1 && this.$router.options.routes[n].name) {
          para.name = this.$router.options.routes[n].name;
          para.params = para.query;
          delete para.path;
          delete para.query;
        }
      }
      this.$store.commit("setRouterViews", para);
      this.$router.push(para);
    },
    goLogout() {
      if (confirm('确定退出？')) {
        this.logout();
      }
    },
    childEvent(p) {
      if (p.cmd == "showmodal") {
        this.modalshow = true;
      } else if (p.cmd == "hidemodal") {
        this.modalshow = false;
      } else if (p.cmd == "showlogin") {
        this.loginmodal = true;
      } else if (p.cmd == "hidelogin") {
        this.loginmodal = false;
      } else if (p.cmd == "routergoto") {
        this.routergoto(p.data);
      } else if (p.cmd == "hideSpining") {
        this.spining = false;
      } else if (p.cmd == "showSpining") {
        this.spining = true;
      } else if (p.cmd == "href") {
        window.location.href = p.data;
      } else if (p.cmd == "confirmMenu") {
        this.confirmMenu(p);
      } else {
        console.log(p);
      }
    },
    jaccountLogin() {
      window.location.href =
        "https://jaccount.sjtu.edu.cn/oauth2/authorize?response_type=code&scope=basic%20card_info%20profile&client_id=dfRu8PqSrTiIjzRu4ANE&redirect_uri=https%3A%2F%2Fbiocore.sjtu.edu.cn%2Fapi%2Fauth%2fjaccount&state=meetingRoom";
    },
    subLogin() {
      if (!this.registered) return this.register();
      if (
        !/^[a-zA-Z][a-zA-Z0-9_-]{2,}$|^\d{11}$|^[a-zA-Z0-9._-]{3,}@[a-zA-Z0-9]{3,}\.[a-zA-Z0-9.]{2,}$/.test(
          this.loginData.username
        )
      ) {
        return this.$Message.error({
          content: "账户名必须是字母数字，字母开头，长度6位及以上!",
          background: true,
        });
      } else if (!/.{5,}/.test(this.loginData.password)) {
        return this.$Message.error({
          content: "密码长度需6位及以上",
          background: true,
        });
      }
      return this.login(
        this.loginData.username,
        this.loginData.password,
        false
      ).then(() => {
        this.loginmodal = false;
        this.loginData = {};
      });
    },
    register() {
      if (!/^[a-zA-Z][a-zA-Z0-9_-]{3,}/.test(this.loginData.account)) {
        return this.$Message.error(
          "账户名必须是字母数字，字母开头，长度4位及以上!"
        );
      } else if (
        !/[0-9]/.test(this.loginData.password) ||
        !/[a-zA-Z]/.test(this.loginData.password) ||
        !/.{6,}/.test(this.loginData.password)
      ) {
        return this.$Message.error("密码必须包含字母和数字，长度6位及以上。");
      } else if (this.loginData.password != this.loginData.password2) {
        return this.$Message.error("两次密码不一致！");
      } else if (!/^[0-9]{11}$/.test(this.loginData.mobile)) {
        return this.$Message.error("目前只支持11位号码的手机！");
      } else if (
        !/^((\w+)|(\w+[!#$%&'*+\-,./=?^_`{|}~\w]*[!#$%&'*+\-,/=?^_`{|}~\w]))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.)|(([a-zA-Z0-9-]+\.)+))([a-zA-Z]{2,10}|[0-9]{1,3})(\]?)$/.test(
          this.loginData.email
        )
      ) {
        return this.$Message.error("邮箱格式不正确！");
      }
      this.db_api("post", "/api/account/signup", this.loginData).then(
        (res) => {
          if (res[0].result) {
            this.registered = true;
            this.subLogin().then(this.routergoto("userMenu"));
          }
        }
      );
    },
    confirmMenu(options) {
      console.log("options", options);
      this.confirmOptions = options;
      //if (!options.resolve){this.confirmOptions.resolve=()=>{}}
      //if (!options.reject){this.confirmOptions.reject=()=>{}}
      this.confirmShow = true;
      /* return new Promise((resolve,reject)=>{
            this.resolve=()=>{resolve();this.confirmShow=false;}
            this.reject=()=>{reject();this.confirmShow=false;}
        }) */
    },
    myInfo() {
      this.routergoto(this.base + "/userMenu");
    },
  },
};
</script>


<style>
#app {
  font-family: "Avenir", Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: center;
  color: #2c3e50;
  margin-top: 4em;
}

img {
  width: 100%;
  border-radius: 0.5em;
}

body {
  word-break: break-all;
  word-wrap: break-all;
}

button {
  margin-right: 5px;
}

.mainNav.ivu-menu .ivu-select-dropdown {
  background: rgba(18, 74, 42, 0.9);
}

.mainNav .ivu-menu-item {
  font-size: 16px;
}

.mainNav .ivu-menu-item-group-title {
  color: #c6ee74;
}

.mainNav.ivu-menu .ivu-menu-submenu .ivu-select-dropdown a.ivu-menu-item {
  color: #d8d8d8;
}

.mainNav.ivu-menu .ivu-menu-submenu .ivu-select-dropdown a.ivu-menu-item:hover {
  background: #599;
  color: #fff;
}

.User button {
  border: #bbb 1px solid;
}

.demo-spin-icon-load {
  animation: ani-demo-spin 1s linear infinite;
}

li>button {
  margin: 0 0.2em 0 0.2em;
}

.rtv,
.lpage div {
  display: -webkit-box;
  display: -moz-box;
  display: -webkit-flex;
  display: -ms-flexbox;
  display: flex;
  flex-direction: row;
  padding: 0.5%;
}

.litem>div {
  flex-direction: column;
  align-items: center;
  margin: 1%;
}

.lpage {
  width: 100%;
  flex-wrap: wrap;
  justify-content: flex-start;
}

div.litem {
  min-width: 250px;
  background: rgba(255, 255, 255, 0.3);
  border-radius: 0.3em;
  padding: 0 1% 0 1%;
}

.confirm .ivu-modal-footer {
  text-align: center;
}

.Login {
  width: 30%;
  min-width: 200px;
}

#container {
  background: #fff;
}

.ivu-form-item-content {
  display: flex;
}

.ivu-form-item-content>label {
  height: auto;
  width: 6em;
}

.pressed {
  color: #3399ff;
}

.leftbar {
  width: 60%;
}

.rightbar {
  width: 40%;
}

.details {
  color: #cd3;
}

.sep {
  margin: 1em;
  font-size: 20px;
}

div.ivu-modal-header {
  padding-top: 2em;
}

.llabel {
  text-align: right;
  padding-right: 2%;
}

td>hr {
  border: none;
  border-top: 1px solid #eee;
  margin: 1em auto;
  padding: 1em;
}

header {
  display: none;
}

.ivu-notice {
  text-align: left;
}
</style>